import qs from 'qs';
import { updatedDiff } from 'deep-object-diff';

const state = {
    defaultValues: {},
    filters: {},
    query: {},
    totalResults: 0,
};

const getters = {
    activeFilters: (state, { activeFilterKeys }) =>
        activeFilterKeys.filter(key => !['page', 'length'].includes(key)),

    activeFilterKeys: state =>
        Object.keys(updatedDiff(
            JSON.parse(JSON.stringify(state.defaultValues)),
            state.query,
        )),
};

const actions = {
    resetFilters({ commit }) {
        commit('updateQuery', JSON.parse(JSON.stringify(state.defaultValues)));
    },
};

const mutations = {
    setAllFilters(state, value) {
        state.filters = value;

        state.defaultValues = Object.keys(state.filters).reduce(
            (result, key) => {
                result[key] = state.filters[key].value;
                return result;
            },
            {},
        );

        const queryStringParsed = qs.parse(window.location.search, {
            encode: false,
            ignoreQueryPrefix: true,
        });
        const queryStringFromStorageParsed = qs.parse(window.localStorage.getItem('kanban-filters'), {
            encode: false,
            ignoreQueryPrefix: true,
        });
        const queryString = Object.keys(queryStringParsed).length !== 0
            ? queryStringParsed
            : queryStringFromStorageParsed;

        state.query = Object.assign(
            JSON.parse(JSON.stringify(state.defaultValues)),
            queryString,
        );
    },

    updateQuery(state, query) {
        state.query = {
            ...state.query,
            ...query,
        };

        const queryStringified = qs.stringify(state.query, {
            addQueryPrefix: true,
            encode: false,
        });

        window.localStorage.setItem('kanban-filters', queryStringified);

        window.history.replaceState(
            {},
            '',
            window.location.pathname + queryStringified,
        );
    },

    setTotalResults(state, total) {
        state.totalResults = total;
    },
};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
